import React from 'react';

const experiences = [
  {
    company: 'Etsy',
    role: 'Director of Engineering',
    period: 'July 2022 – Present',
    current: true,
    summary:
      "Leading SRE and Platform engineering teams accountable for 99.95% uptime across 100+ critical services powering Etsy's marketplace.",
  },
  {
    company: 'Ombud',
    role: 'Director of Engineering',
    period: 'April 2021 – July 2022',
    current: false,
    summary:
      'Shaped engineering direction alongside technical leads to position the platform for growth, establishing OKRs that were later adopted company-wide and re-organizing the engineering org around SRE, Platform, and Tech Lead roles. Automated KPI reporting with Grafana and Python, and cut the hiring pipeline from 14 steps to 4, reducing candidate time-to-decision by four weeks.',
  },
  {
    company: 'Snapchat',
    role: 'Engineering Manager, Release Engineering',
    period: 'April 2020 – April 2021',
    current: false,
    summary:
      'Transformed client app releases from manual bi-weekly cycles to fully automated weekly releases — the largest process change at Snapchat in three years. Merged the Release Engineering and Developer Tooling teams for tighter collaboration, onboarded engineers toward automation-first thinking, and designed an onboarding framework that reduced time-to-deployment for new apps by 80%.',
  },
  {
    company: 'Comcast',
    role: 'Director, SRE/DevOps',
    period: 'April 2018 – April 2020',
    current: false,
    summary:
      'Owned reliability for a CDN serving 100B+ requests per day to millions of US clients, supporting hundreds of millions in revenue. Redesigned the hardware deployment pipeline with Ansible and Terraform to cut deployment time by 90%, drove adoption of CI/CD for faster and more stable feature delivery, and maintained regular executive communication on CDN state and roadmap.',
  },
  {
    company: 'PGi / ReadyTalk',
    role: 'Engineering Manager',
    period: 'March 2017 – April 2018',
    current: false,
    summary:
      'Led the SRE team through a full infrastructure modernization from on-premise data centers to AWS and Kubernetes. Established organization-wide metrics and monitoring standards, and moved the team from waterfall to an agile CI/CD approach using SonarQube, Ansible, Packer, and Docker.',
  },
  {
    company: 'ReadyTalk',
    role: 'SDET II & DevOps Engineer',
    period: 'May 2014 – March 2017',
    current: false,
    summary:
      'Maintained and enhanced the developer toolset including Jenkins, Artifactory, and deployment automation scripts. Owned the production release process for the entire ReadyTalk codebase on a six-week cadence.',
  },
  {
    company: 'NetApp (via LSI)',
    role: 'Automation Engineer',
    period: '2007 – 2014',
    current: false,
    summary:
      "Designed and built a full automated build, deploy, and test system from scratch, with a Perl/PHP backend and JavaScript/HTML/CSS frontend for reporting build and test statuses. Served as lead Automation QA Engineer on the T10-PI project, automating a large share of the project's test coverage.",
  },
];

function Experience() {
  return (
    <section id="experience" className="max-w-[1100px] mx-auto px-8 py-[120px] border-t border-white/5">
      <p className="text-label-sm text-primary uppercase tracking-[0.2em] mb-16">Career</p>
      <div className="relative">
        <div className="absolute left-[7px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-primary via-primary/10 to-transparent" />
        <div className="space-y-16">
          {experiences.map((exp) => (
            <div key={`${exp.company}-${exp.period}`} className="relative pl-12">
              <div
                className={`absolute left-0 top-2 w-4 h-4 rounded-full bg-background border-2 ${
                  exp.current
                    ? 'border-primary shadow-[0_0_15px_rgba(77,142,255,0.4)]'
                    : 'border-primary/20'
                }`}
              />
              <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-12">
                <span className="text-label-sm text-on-surface-variant whitespace-nowrap shrink-0 w-44">
                  {exp.period}
                </span>
                <div>
                  <h3 className="text-headline-md text-on-background">{exp.company}</h3>
                  <p className="text-label-sm text-primary/60 uppercase tracking-widest mt-1 mb-3">
                    {exp.role}
                  </p>
                  <p className="text-body-md text-on-surface-variant">{exp.summary}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
